var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgXiraIcloud = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 40,
    fill: "none",
    viewBox: "0 0 195 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 30,
    x: 0.5,
    y: 5.5,
    stroke: "#DEDEDE",
    rx: 9.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F97300",
    d: "M71.458 29.02V13.94h2.132v15.08h-2.132zm0-17.888V9h2.132v2.132h-2.132zM77.166 29.02V17.086c0-.867.303-1.603.91-2.21.624-.624 1.37-.936 2.236-.936h8.476v2.132h-8.476c-.277 0-.52.104-.728.312-.19.19-.286.425-.286.702V29.02h-2.132zM93.917 29.02c-.867 0-1.612-.303-2.236-.91-.607-.624-.91-1.37-.91-2.236v-5.46h13.208v-3.328c0-.277-.104-.511-.312-.702-.191-.208-.425-.312-.702-.312H90.771V13.94h12.194c.884 0 1.629.312 2.236.936.624.607.936 1.343.936 2.21V29.02h-12.22zm0-2.132h10.062v-4.342H92.903v3.328c0 .277.095.52.286.728.208.19.45.286.728.286zM60.696 19.66l4.914-5.72h2.782v.026L62.1 21.35l6.318 7.644v.026H65.61l-4.914-6.032V19.66z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M53 28.994v.026h2.808l4.888-6.032V19.66l-4.888-5.72H53v.026l6.292 7.384L53 28.994z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#666A73",
    d: "M186.163 16.25c.057-.41.087-.828.087-1.25 0-4.825-3.925-8.75-8.75-8.75-3.097 0-5.958 1.668-7.505 4.27-.78-.342-1.622-.52-2.495-.52-3.445 0-6.25 2.805-6.25 6.25 0 .128.003.253.013.375C157.615 17.683 155 21.078 155 25c0 4.825 3.925 8.75 8.75 8.75h22.5c4.825 0 8.75-3.925 8.75-8.75 0-4.852-3.935-8.79-8.837-8.75z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#575757",
    d: "M140.219 20.219h-8.438V11.78c0-.431-.35-.781-.781-.781-.431 0-.781.35-.781.781v8.438h-8.438c-.431 0-.781.35-.781.781 0 .431.35.781.781.781h8.438v8.438c0 .431.35.781.781.781.431 0 .781-.35.781-.781V21.78h8.438c.431 0 .781-.35.781-.781 0-.431-.35-.781-.781-.781z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgXiraIcloud, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/xira_icloud.4edc7985.svg";
export { ForwardRef as ReactComponent };